module.exports = __webpack_public_path__ + "0f5906aaa117022227abc46b93a33368.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/card_bg.svg
// module id = 403
// module chunks = 0